/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleLecturerResponse } from './moduleLecturerResponse';

export type GenericApiResponseListModuleLecturerResponseData = ModuleLecturerResponse[] | null;
